import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { List, Map } from 'immutable'
import TileV2 from 'components/Tile.v2'
import Row, { STYLES } from 'components/Row.v2'

function renderItem (item, params, props) {
  const { index } = params
  const {
    adminTitle,
    rowPlacement,
    sectionIndex,
    upstreamContext,
    legacyData,
    uiLocation,
  } = props

  return (
    <TileV2
      data={item || Map()}
      sectionIndex={sectionIndex}
      rowPlacement={rowPlacement}
      adminTitle={adminTitle}
      index={index}
      upstreamContext={upstreamContext}
      legacyData={legacyData}
      uiLocation={uiLocation}
    />
  )
}

function TileGridV2 (props) {
  const {
    tileData = List(),
    disableHover,
    reducedGrid,
  } = props

  return (
    <div className="tile-grid-v2">
      <Row
        items={tileData || List()}
        createAccessor={() => null}
        style={reducedGrid ? STYLES.S12334 : STYLES.S12345}
        asGrid
        disableHover={disableHover}
      >{(item, data) => renderItem(item, data, props)}
      </Row>
    </div>
  )
}

TileGridV2.propTypes = {
  tileData: ImmutablePropTypes.list.isRequired,
  upstreamContext: ImmutablePropTypes.map.isRequired,
  adminTitle: PropTypes.string.isRequired,
  sectionIndex: PropTypes.number.isRequired,
  rowPlacement: PropTypes.number.isRequired,
  disableHover: PropTypes.bool,
  legacyData: PropTypes.bool,
  reducedGrid: PropTypes.bool,
}

TileGridV2.defaultProps = {
  tileData: List(),
  upstreamContext: Map(),
  sectionIndex: 1,
  rowPlacement: 1,
  disableHover: false,
  legacyData: true,
  reducedGrid: false,
}

export default TileGridV2
